import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './style.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// 初始化认证状态
import { useAuthStore } from '@/stores/auth.js'
import { tokenRefreshManager } from '@/utils/auth.js'
import { setupPermissionDirective } from '@/directives/permission.js'

// 注册权限指令
setupPermissionDirective(app)

const initAuth = async () => {
    const authStore = useAuthStore()

    try {
        // 初始化认证状态
        await authStore.initAuth()

        // 如果用户已登录，启动token自动刷新并加载G币余额
        if (authStore.isAuthenticated) {
            tokenRefreshManager.startAutoRefresh()
            // 加载G币余额用于Header显示
            authStore.loadCurrencyBalance('G').catch(err => {
                console.warn('初始化时加载G币余额失败:', err)
            })
        }
    } catch (error) {
        console.error('认证初始化失败:', error)
    }
}

// 在应用挂载前初始化认证
initAuth().then(() => {
    app.mount('#app')
})
